import { action, computed, makeObservable } from 'mobx';
import {DraggableId, DragUpdate, DroppableId} from '../../../../../lib/components/drag-n-drop';
import {logger} from '../../../../../lib/helpers';
import {X9ContentStateStore} from '../../common/X9ContentStateStore';
import {
  MQDataPair,
  MQDataPairState,
  MQMatchingQuestion,
  MQMatchingQuestionState,
  MQOptions
} from '../models';
import {indexFromDraggableId, indexFromDroppableId} from './dnd-utils';

export class DndMatchingQuestionStore {
  constructor(readonly contentSnapshotId: number,
              readonly question: MQMatchingQuestion,
              readonly stateStore: X9ContentStateStore) {
    makeObservable(this);
    this.options = question.options;
    this.dataPairs = question.dataPairs;
  }

  options: MQOptions;
  dataPairs: readonly MQDataPair[];

  @computed
  get state(): MQMatchingQuestionState | null {
    return this.stateStore.getContentState<MQMatchingQuestionState>(this.contentSnapshotId);
  }

  @computed
  get dataPairStates(): readonly MQDataPairState[] {
    const state = this.state;
    const dataPairStates: MQDataPairState[] = [];

    this.dataPairs.map((value, key) => {
      Object.assign(dataPairStates, {[key]: {matchedTo: null, checked: false}})
    })
    return (state === null) ? dataPairStates : state.DataPairStates;
  }

  @computed
  get rightSideOrder(): readonly number[] {
    const state = this.state;
    const rightSideOrder: number[] = [];

    this.dataPairs.map((value, key) => {
      rightSideOrder.push(key)
    })
    return state === null ? rightSideOrder.sort((a, b) => 0.5 - Math.random()) : state.RightSideOrder;
  }

  canDropOn = (draggableId: DraggableId, source: DroppableId, destination: DroppableId): boolean => {
    return true;
  };

  onDragUpdate = (update: DragUpdate) => {
    logger.log('DndGapFillingStore.onDragUpdate', update);
  };

  @action
  onDragEnd = (result: DragUpdate): void => {
    logger.log('DndGapFillingStore.onDragEnd', result);

    const {draggableId, fromDroppableId, toDroppableId} = result;
    const itemIndex = indexFromDraggableId(draggableId);
    const fromDroppableIndex = indexFromDroppableId(fromDroppableId);
    const toDroppableIndex = indexFromDroppableId(toDroppableId);

    if (fromDroppableId === toDroppableId)
      return;

    if (fromDroppableIndex !== null) {
      this.updateDataPairState(fromDroppableIndex,
        {matchedTo: null, checked: false});
    }

    if (toDroppableIndex !== null) {
      this.updateDataPairState(toDroppableIndex,
        {checked: false, matchedTo: itemIndex});
    }
  };

  @action
  check = () => {
    for (let index = 0; index < this.dataPairStates.length; index++) {
      const state = this.dataPairStates[index];
      if (state.checked || state.matchedTo === null)
        continue;
      this.updateDataPairState(index, {matchedTo: state.matchedTo, checked: true});
    }
  };

  @action
  updateDataPairState(index: number, dataPairState: MQDataPairState) {
    const newDataPairStates = this.dataPairStates!.slice();
    newDataPairStates[index] = dataPairState;
    this.stateStore.setContentState<MQMatchingQuestionState>(
      this.contentSnapshotId,
      {RightSideOrder: this.rightSideOrder!, DataPairStates: newDataPairStates});
  }
}
